(ns io.repliance.schemas.user-preferences)

(def UserPreferences
  [:map
   [:initial-analysis-collapsed-state
    {:optional true
     :ui/label "Analyses initially collapsed"
     :default false}
    :boolean]
   [:notifications-up
    {:optional true
     :ui/label "Show notifications in the upper right corner, instead of down right corner"
     :default false}
    :boolean]])
